import React from 'react'

import { useAppSelector } from '../../hooks/useStore'
import { getCard, getCarouselLayout, isLive } from '../CarouselTS'
import Carousel from '../CarouselTS/Carousel'
import CarouselTitle from '../CarouselTS/CarouselTitle'
import EvergreenUrgentBanner, {
  EVERGREEN_BANNER_SLUG,
} from '../EvergreenUrgentMessaging'
import CollectionLane from './CollectionLane'
import CollectionLanes from './CollectionLanes'

import type { RootState } from '../../reducers/types/reducerTypes'
import type { CollectionsSetProps } from './types'

function CollectionsSet({
  collections,
  singleRow,
  extraTts,
  hasHeaderComponent = false,
  handleInfiniteFetching,
  onArrowPress,
  className = '',
  hideMetadata = true,
  pageDetails = {},
  onFocus,
  handelWheelExternally,
}: CollectionsSetProps) {
  const { short_common_name: shortCommonName } = useAppSelector(
    (state: RootState) => state.station
  )

  return (
    <CollectionLanes
      collections={collections}
      singleRow={singleRow}
      hasHeaderComponent={hasHeaderComponent}
      className={className}
      handelWheelExternally={handelWheelExternally}
      onExternalFocus={onFocus}
    >
      {(collection, handleCarouselFocus, index) => {
        const handleFocus = onFocus || handleCarouselFocus

        // Handle banner collection
        if (collection.slug === EVERGREEN_BANNER_SLUG) {
          return (
            <CollectionLane collection={collection} key={collection.slug}>
              <EvergreenUrgentBanner onFocus={handleFocus} />
            </CollectionLane>
          )
        }

        // Handle regular collections
        const isLiveCollection = isLive(collection.slug)
        const title = isLiveCollection
          ? `Watch ${shortCommonName} Now`
          : collection.title

        const layout = getCarouselLayout(collection)
        const nextCollection = collections[index + 1]
        const adjustedLayout =
          nextCollection?.slug === EVERGREEN_BANNER_SLUG
            ? { ...layout, carouselMarginBottom: 170 }
            : layout

        return (
          <CollectionLane collection={collection} key={collection.slug}>
            <CarouselTitle isLive={isLiveCollection} title={title} />
            <Carousel
              collection={collection}
              layout={adjustedLayout}
              card={getCard(collection)}
              onFocus={handleFocus}
              ttsText={extraTts ? `${extraTts} ${title}` : title}
              index={index}
              handleInfiniteFetching={handleInfiniteFetching}
              onArrowPress={onArrowPress}
              hideMetadata={hideMetadata}
              pageDetails={pageDetails}
            />
          </CollectionLane>
        )
      }}
    </CollectionLanes>
  )
}

export default CollectionsSet
